<template>
  <van-popup
    v-model="show"
    position="bottom"
    class="filter-modal"
    round
    :style="{ height: 'auto', maxHeight: '90%' }"
    @closed="$emit('close')"
  >
    <div class="modal-header">
      <span class="title">投诉过滤</span>
      <van-icon name="arrow-down" class="close-icon" @click="show = false" />
    </div>

    <div class="modal-content">
      <!-- 投诉渠道 -->
      <div class="section">
        <div class="section-title">投诉渠道</div>
        <div class="channel-grid">
          <div
            v-for="item in complainChannelList"
            :key="item.value"
            class="channel-item"
            :class="{ active: selectedChannel === item.value }"
            @click="selectedChannel = item.value"
          >
            {{ item.label }}
          </div>
        </div>
      </div>

      <!-- 统计规则 -->
      <div class="section">
        <div class="section-title">统计规则</div>
        <div class="rule-list">
          <div
            v-for="item in analysisRuleList"
            :key="item.code"
            class="rule-card"
            :class="{ active: selectedRule === item.code }"
            @click="selectedRule = item.code"
          >
            <div class="rule-name">{{ item.value }}</div>
            <div class="rule-remark">{{ item.remark }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="modal-footer van-hairline--top">
      <van-button class="btn-reset" @click="onReset">重置</van-button>
      <van-button class="btn-confirm" type="primary" @click="onConfirm">确定</van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "ChannelAndRuleFilterModal",
  props: {
    // 投诉渠道数组 [{ value, label }]
    complainChannel: {
      type: Array,
      default: () => []
    },
    // 统计规则数组 [{ code, remark, value }]
    analysisRule: {
      type: Array,
      default: () => []
    },
    // 初始选中的渠道值
    initialChannel: {
      type: String,
      default: ""
    },
    // 初始选中的规则 code
    initialRule: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: true,
      selectedChannel: this.initialChannel, 
      selectedRule: this.initialRule
    };
  },
  computed: {
    // 补齐“全部”选项以便展示
    complainChannelList() {
      const all = { value: "", label: "全部" };
      return [all, ...this.complainChannel];
    },
    analysisRuleList() {
      return this.analysisRule;
    }
  },
  methods: {
    onReset() {
      this.selectedChannel = "";
      this.selectedRule = "";
    },
    onConfirm() {
      this.$emit("confirm", {
        channel: this.selectedChannel,
        rule: this.selectedRule
      });
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
.filter-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .modal-header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
    .close-icon {
      position: absolute;
      right: 20px;
      font-size: 20px;
      color: #999;
    }
  }

  .modal-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 16px 20px;

    .section {
      margin-top: 20px;
      .section-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 16px;
      }
    }

    // 渠道网格 3列
    .channel-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      .channel-item {
        width: calc((100% - 20px) / 3);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f7f8fa;
        border: 1px solid #f7f8fa;
        border-radius: 4px;
        font-size: 14px;
        color: #666;
        transition: all 0.2s;

        &.active {
          background: #36b374;
          color: #fff;
          border-color: #36b374;
        }
      }
    }

    // 规则列表
    .rule-list {
      .rule-card {
        padding: 12px 16px;
        background: #fff;
        border: 1px solid #ebedf0;
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all 0.2s;

        .rule-name {
          font-size: 15px;
          font-weight: 500;
          color: #333;
          margin-bottom: 4px;
        }
        .rule-remark {
          font-size: 13px;
          color: #999;
          line-height: 1.4;
        }

        &.active {
          background: #36b374 !important;
          border-color: #36b374 !important;
          .rule-name, .rule-remark {
            color: #fff !important;
          }
        }
      }
    }
  }

  .modal-footer {
    padding: 12px 16px;
    display: flex;
    gap: 12px;
    background: #fff;

    .btn-reset {
      flex: 1;
      height: 44px;
      border: 1px solid #ebedf0;
      color: #36b374;
      font-size: 16px;
    }
    .btn-confirm {
      flex: 2;
      height: 44px;
      background: #36b374;
      border: none;
      font-size: 16px;
    }
  }
}
</style>
